import { AlertTriangle, CheckCircle2, Clock, Loader2, SearchX, XCircle } from "lucide-react";
import type { FilterColumn } from "@/components/shared/FilterDropdown";
import type { LandscapeRunStatus } from "@/types";
import { RUN_STATUS_LABEL, RUN_STATUS_ORDER } from "@/utils/landscapeRunStatus";

// Matches the prototype's bold, high-contrast column headers -- this app's
// shared TableHead default (font-normal, muted) is intentionally lighter
// for other tables, so it's overridden per-column here rather than globally.
export const HEADER_CLASS = "text-xs font-semibold text-foreground";

/**
 * `components/work-run-log.md § The screen` -- one row per `WorkRunStatus`,
 * in `RUN_STATUS_ORDER`: Clock, Loader2 (spinning), AlertTriangle,
 * CheckCircle2, SearchX, XCircle.
 */
export const STATUS_ICON: Record<LandscapeRunStatus, typeof CheckCircle2> = {
  queued: Clock,
  running: Loader2,
  stopped: AlertTriangle,
  succeeded_with_keywords: CheckCircle2,
  succeeded_without_keywords: SearchX,
  failed: XCircle,
};

export const STATUS_TEXT_CLASS: Record<LandscapeRunStatus, string> = {
  queued: "text-muted-foreground",
  running: "text-status-info-strong",
  stopped: "text-status-warning-strong",
  succeeded_with_keywords: "text-status-success-strong",
  succeeded_without_keywords: "text-muted-foreground",
  failed: "text-status-error-strong",
};

/**
 * Options built from `RUN_STATUS_ORDER` + `RUN_STATUS_LABEL` so this
 * dropdown and the KPI cards can never offer different words for one
 * value (`components/work-run-log.md § The screen`).
 */
export const STATUS_FILTER_COLUMNS: FilterColumn[] = [
  {
    id: "status",
    label: "Status",
    options: RUN_STATUS_ORDER.map((status) => ({ value: status, label: RUN_STATUS_LABEL[status] })),
  },
];
